var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEvents(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 8.5V11H2V3H7.5V2H2C1.73478 2 1.48043 2.10535 1.29289 2.29289C1.10536 2.48043 1 2.73478 1 3V11C1 11.2652 1.10536 11.5196 1.29289 11.7071C1.48043 11.8946 1.73478 12 2 12H6V14H4V15H12V14H10V12H14C14.2652 12 14.5196 11.8946 14.7071 11.7071C14.8946 11.5196 15 11.2652 15 11V8.5H14ZM9 14H7V12H9V14Z",
    fill: "#161616"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 7H8.5C8.41153 6.99998 8.32465 6.9765 8.24822 6.93193C8.17179 6.88737 8.10856 6.82333 8.06497 6.74634C8.02138 6.66935 7.999 6.58218 8.00011 6.49371C8.00123 6.40525 8.02579 6.31867 8.0713 6.2428L11.0713 1.2428C11.1157 1.16871 11.1786 1.1074 11.2537 1.06482C11.3289 1.02225 11.4138 0.999873 11.5002 0.999873C11.5865 0.999873 11.6714 1.02225 11.7466 1.06482C11.8217 1.1074 11.8846 1.16871 11.929 1.2428L14.929 6.2428C14.9745 6.31869 14.9991 6.4053 15.0002 6.49379C15.0013 6.58228 14.9789 6.66947 14.9353 6.74647C14.8916 6.82347 14.8284 6.88751 14.7519 6.93205C14.6754 6.97659 14.5885 7.00004 14.5 7ZM9.38305 6H13.617L11.5 2.4718L9.38305 6Z",
    fill: "#161616"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEvents);
export default __webpack_public_path__ + "static/media/events.2ca7f1824624ce2bfef4ec7e17a873b7.svg";
export { ForwardRef as ReactComponent };